import { createContext, useState, useContext, PropsWithChildren } from 'react'
import { Toast, ToastContainer } from 'react-bootstrap';

interface ToastInterface {
  id: string;
  content: string;
  title: string;
  variant: string
}

interface ToastsContextInterface {
  showToast?: Function;
  removeToast?: Function;
}

const ToastsContext = createContext<ToastsContextInterface>({});

export const ToastsProvider = ({ children }: PropsWithChildren) => {
  const [toasts, setToasts] = useState<Array<ToastInterface>>([]);

  const showToast = (id: string, content: string, title: string, variant: string) => {
    const found = toasts.find(toast => toast.id === id);
    if (found) return;

    const toast = { id, content, title, variant, show: true };
    setToasts((toasts) => toasts.concat(toast));
  };

  // avoid creating a new fn on every render
  const removeToast = (id: string) => () => {
    const newToasts = toasts.filter(t => t.id !== id);
    setToasts(newToasts);
  };

  return (
    <ToastsContext.Provider value={{ showToast, removeToast }}>
      {children}

      <ToastContainer className="p-3" position="top-end" style={{zIndex:6969}}>
        {toasts.map(({ id, content, title, variant }) => (
          <Toast key={id} bg={variant} delay={3000} onClose={removeToast(id)} autohide>
            <Toast.Header>
              {/* <img src={logo} width={20} /> */}
              <strong className="me-auto">{title}</strong>
              {/* <small>11 mins ago</small> */}
            </Toast.Header>
            <Toast.Body style={{whiteSpace:'pre-line'}}>{content}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastsContext.Provider>
  )
}

export const useToasts = () => useContext(ToastsContext);

// TODO: inserire logo con solo la A (BIANCA)